import { useState} from 'react';
import { Icon } from '@gplibraries/react/components';
import EditUserModal from './EditUserModal';




export default function EditUserAction({
  user,
  allPermissions,
  onSavePermissions,
  onDelete,
  dealerInfo
}) {
  const [open, setOpen] = useState(false);

  async function handleSave(updatedUser) {
    if (!updatedUser) return;
    await onSavePermissions(updatedUser);
    setOpen(false);
  }

  function handleDeleteUser() {
    onDelete(user.employee_user);
    setOpen(false);
  }

  return (
    <>
      <button className="action-btn" onClick={() => setOpen(true)}>
        <Icon glyph="pencil" /> Edit
      </button>

      {open && (
        <EditUserModal
          user={user}
          allPermissions={allPermissions}
          dealerInfo={dealerInfo}
          onSave={handleSave}
          onDelete={handleDeleteUser}
          onClose={() => setOpen(false)}
        />
      )}
    </>
  );
}

